<div class="ng-autocomplete w-100">  
      <ng-autocomplete 
        #searchInput
        [class]='classSearch'
        [data]="data"
        [searchKeyword]="keyword"
        placeholder="Buscar transporte"
        (selected)='selectSearchTransport($event)'
        (inputChanged)='debouncedSearchInput($event)' 
        (inputCleared)='clearedInputSearch()'                              
        (closed)='closedSearchPanel()'                              
        [itemTemplate]="itemTemplate"
        [notFoundTemplate]="notFoundTemplate">                                 
      </ng-autocomplete>
      <ng-template #itemTemplate let-item>
        <a style="padding: 8px 15px 5px;" class="f-s-12 p-10" [innerHTML]="item.owner"></a>
        <p style="padding: 0px 20px 5px; font-size: 9px !important; margin-bottom: 4px; margin-top: -5x;">
          <ng-container *ngIf="item.reference_name != null">
            <span [innerHTML]="item.reference_name"></span>
            <span class="m-r-5 m-l-3">/</span>
          </ng-container>
          <i class="fas fa-bus-alt m-r-5"></i> 
          <span [innerHTML]="item.vehicle_type"></span>
          (<span class="m-l-2 m-r-2" [innerHTML]="item.capacity"></span> pax)
        </p>
      </ng-template>   
      <ng-template #notFoundTemplate let-notFound>
        <p style="padding-top: 5px;
        margin-bottom: 5px;
        font-weight: 500;" *ngIf="isTypedSearch">No se encontraron registros</p>
      </ng-template>
  </div>
  